/* RESPONSIBLE TEAM: team-actions */
import AppstoreIndexController from 'embercom/controllers/base/appstore/index';

export default AppstoreIndexController;
